
<template>
  <div>
    <v-icon small v-for="award in awards" :key="award.code">{{award.mdi_icon}}</v-icon>
  </div>
</template>

<script>
export default {
  name: "AwardList",
  props: {
    awards: {
      type: Array,
      required: true
    }
  }
};
</script>